import { createFileRoute } from "@tanstack/react-router"
import { AdminAdsPerformanceWrapper } from "./-AdsPerformancePage"
import type { EAdsPerformanceTab } from "./-AdsPerformancePage"

const ADS_PERFORMANCE_TABS: EAdsPerformanceTab[] = ["inventory", "mapping", "roas", "audit"]

const parseAdsPerformanceView = (value: unknown): EAdsPerformanceTab => {
  if (typeof value === "string" && ADS_PERFORMANCE_TABS.includes(value as EAdsPerformanceTab))
    return value as EAdsPerformanceTab
  return "inventory"
}

export const Route = createFileRoute("/admin/ads-performance")({
  validateSearch: (search): { view: EAdsPerformanceTab } => ({
    view: parseAdsPerformanceView(search.view),
  }),
  component: AdminAdsPerformanceWrapper,
})
